import React from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import BackgroundRemoverPage from "@/pages/BackgroundRemoverPage";
import PassportStudioPage from "@/pages/PassportStudioPage";
import RestorePage from "@/pages/RestorePage";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/toaster";

export default function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BackgroundRemoverPage />} />
          <Route path="/passport" element={<PassportStudioPage />} />
          <Route path="/restore" element={<RestorePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}
